export default __webpack_public_path__ + "static/media/NoResult.88d5003d.svg";